// extracted by mini-css-extract-plugin
export default {"alert":"styles__alert___6st4G","icon":"styles__icon___dDRC-","spacer":"styles__spacer___heKoO"};